import { Types } from './type';

export const transformTypes = (types: Types): Types => ({
  ...types,
});
